export enum ConnectionStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  PENDING_APPROVAL = 'Pending Approval',
  DECLINED = 'Declined',
  INVITED = 'Invited',
  INVITATION_EXPIRED = 'Invitation Expired',
  NOT_INVITED = 'Not Invited',
  IGNORED = 'Ignored',
  ALL = 'All',
}
export enum AuthenticationType {
  PASSWORD = 'Password',
  TWO_FA = '2FA',
  PASSWORD_LESS = 'PasswordLess',
}

export enum ConfirmationMethod {
  MANUAL = 'Manual',
  AUTOMATIC = 'Automatic',
  UNKNOWN = 'Unknown',
}

export enum InviteMethod {
  INVITE_CODE = 'Invite Code',
  DIRECT_INVITE = 'Direct Invite',
}

export enum InviteCodeCommunicationMode {
  EMAIL = 'Email',
  SMS = 'sms',
  NONE = '',
}
export enum InvitationAction {
  ACCEPTED = 'Accepted',
  IGNORED = 'Ignored',
}

export enum ConnectionIdentifier {
  USER_ORG = 'UserOrgConnection',
  ORG_USER = 'OrgUserConnection',
  B2B = 'B2BConnection',
}
export enum JoinMethod {
  CREATOR = 'Creator',
  INVITE_CODE = 'Invite Code',
  DIRECT_INVITE = 'Direct Invite',
  GENERIC_CODE = 'Generic Code',
}
